import styleInject from '../../node_modules/style-inject/dist/fb3a8d84bb477a96e56a5e12f7d7ac81b9d9799a9277fe852d93ab86a1b81224.cfe-internal.js';

var css_248z = "._23tse{position:absolute;top:-10000px;left:-10000px}";
var classes = {"ariaLiveElement":"_23tse"};
var stylesheet="._23tse{position:absolute;top:-10000px;left:-10000px}";
styleInject(css_248z);

export { classes as default, stylesheet };
